import { render, staticRenderFns } from "./jobApprovalDetail.vue?vue&type=template&id=66361023&scoped=true&"
import script from "./jobApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./jobApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./jobApprovalDetail.vue?vue&type=style&index=0&id=66361023&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66361023",
  null
  
)

export default component.exports